import React, { useEffect } from "react";
import { BsGraphUpArrow, BsGraphDownArrow } from "react-icons/bs";
import { Column } from "@ant-design/plots";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getAllOrders } from "../features/auth/authSlice";

const columns = [
  {
    title: "Order #",
    dataIndex: "orderId",
  },
  {
    title: "Customer",
    dataIndex: "name",
  },
  {
    title: "Product Count",
    dataIndex: "productCount",
  },
  {
    title: "Amount",
    dataIndex: "amount",
  },
  {
    title: "Status",
    dataIndex: "status",
  },
];

const Dashboard = () => {
  const dispatch = useDispatch();
  const orderState = useSelector((state) => state.auth.orders);
  
  useEffect(() => {
    dispatch(getAllOrders("complete"));
  }, [dispatch]);

  const orders = orderState?.data || [];
  
  // Calculate stats
  const totalRevenue = orders.reduce((acc, curr) => acc + (curr.TotalPrice || 0), 0);
  const totalOrders = orders.length;

  // Monthly income chart data
  const monthlyData = [
    { type: "Jan", value: 0 },
    { type: "Feb", value: 0 },
    { type: "Mar", value: 0 },
    { type: "Apr", value: 0 },
    { type: "May", value: 0 },
    { type: "Jun", value: 0 },
    { type: "Jul", value: 0 },
    { type: "Aug", value: 0 },
    { type: "Sep", value: 0 },
    { type: "Oct", value: 0 },
    { type: "Nov", value: 0 },
    { type: "Dec", value: 0 },
  ];

  orders.forEach(order => {
    const month = new Date(order.createdAt).getMonth();
    monthlyData[month].value += order.TotalPrice;
  });

  const tableData = orders.map((order, index) => ({
    key: index,
    orderId: order.OrderID,
    name: `${order.FirstName} ${order.LastName}`,
    productCount: order.Products.length,
    amount: `£${order.TotalPrice}`,
    status: order.PaymentStatus,
  }));

  const brandColor = "#ffd333";
  const config = {
    data: monthlyData,
    xField: "type",
    yField: "value",
    seriesField: "",
    color: ({ type }) => brandColor,
    label: {
      content: (originData) => {
        const val = parseFloat(originData.value);
        if (val > 0) return `£${val.toFixed(0)}`;
      },
      offset: 10,
    },
    legend: false,
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
      },
    },
    meta: {
      type: { alias: "Month" },
      value: { alias: "Income" },
    },
  };

  return (
    <div>
      <h1 className="mb-4 fs-3 title">Dashboard</h1>

      <div className="d-flex justify-content-between align-items-center gap-3 mb-4">
        <div className="d-flex flex-grow-1 justify-content-between align-items-end bg-white p-3 rounded-3">
          <div>
            <p className="mb-0 light">Total Revenue:</p>
            <h4>£{totalRevenue.toFixed(2)}</h4>
          </div>
          <div className="d-flex flex-column align-items-end">
            <h6 className="green">
              <BsGraphUpArrow className="me-1" />
              Live
            </h6>
            <p className="mb-0 light">All time revenue</p>
          </div>
        </div>

        <div className="d-flex flex-grow-1 justify-content-between align-items-end bg-white p-3 rounded-3">
          <div>
            <p className="mb-0 light">Total Orders:</p>
            <h4>{totalOrders}</h4>
          </div>
          <div className="d-flex flex-column align-items-end">
            <h6 className="green">
              <BsGraphUpArrow className="me-1" />
              {totalOrders > 0 ? "Active" : "None"}
            </h6>
            <p className="mb-0 light">Successful payments</p>
          </div>
        </div>

        <div className="d-flex flex-grow-1 justify-content-between align-items-end bg-white p-3 rounded-3">
          <div>
            <p className="mb-0 light">Customers:</p>
            <h4>{new Set(orders.map(o => o.Email)).size}</h4>
          </div>
          <div className="d-flex flex-column align-items-end">
            <h6 className="green">
              <BsGraphUpArrow className="me-1" />
              Reach
            </h6>
            <p className="mb-0 light">Unique emails</p>
          </div>
        </div>
      </div>

      <div className="mb-4">
        <h3 className="sub-title mb-4">Income Statistics</h3>
        <div>
          <Column {...config} />
        </div>
      </div>

      <div className="mb-4 ">
        <h3 className="mb-3 sub-title">Recent Orders</h3>
        <div>
          <Table columns={columns} dataSource={tableData} />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
